import { render, staticRenderFns } from "./MatterLegalNoticeForm.vue?vue&type=template&id=c9aaab76&"
import script from "./MatterLegalNoticeForm.vue?vue&type=script&lang=js&"
export * from "./MatterLegalNoticeForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterLegalNoticeForm.vue?vue&type=style&index=0&id=c9aaab76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports